export default {
  'app.true': 'ใช่',
  'app.false': 'ไม่ใช่',
  'app.403.page': 'ไม่มีสิทธิ์',
  'app.403.page.tip': 'โปรดติดต่อผู้ดูแลระบบเพื่อขอสิทธิ์',
};
